import * as qs from 'qs'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import util from '@/utils'
import auth from '@/utils/auth'
import { Message } from 'element-ui'

const _axios: any = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: true,
  timeout: 50000
})

_axios.interceptors.request.use(
  (config: any) => {
    return config
  },
  (error: Error) => {
    return Promise.reject(error)
  }
)

// respone拦截器
_axios.interceptors.response.use(
  (response: any) => response.data,
  (error: any) => {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          Message.error('抱歉！您没有该项操作权限！')
          break
        case 401:
          router.replace({
            path: 'login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
          break
      }
    }
    return Promise.reject(error.response)
  }
)

// 封装axios
const request = function(
  url = '',
  data = {},
  type = 'get',
  origin = false,
  sort = true
) {
  let options = {},
    params = sort ? util.optionSort(data) : data,
    method = type.toLowerCase()
  if (method === 'get') {
    options = {
      params
    }
  } else if (method === 'post') {
    options = qs.stringify(params, { arrayFormat: 'repeat' })
  }

  return new Promise(async (resolve, reject) => {
    try {
      let res = await _axios[method](url, options)

      if (res.code === '000001') {
        resolve(origin ? res : res.data)
      } else {
        Message.error(res.message)
        reject(res)
      }
    } catch (err) {
      reject(err)
    }
  })
}
export default request
